import React from 'react';
import { BankAccountMoreInfo } from '../../types/api/odt';
import InfoTip from '../Common/InfoTip';

const BankAccountToolTip = ({ moreInfo, handleInfoTipModal }: { moreInfo: BankAccountMoreInfo, handleInfoTipModal: (title: string, content: string) => void }) => {
  return (
    <div className="info-tip-container bwp-panel-row__info-tip">
      <p>
        {moreInfo.label}
      </p>
      <InfoTip
        onClick={() => handleInfoTipModal(moreInfo.title, moreInfo.message)}
      />
    </div>
  );
}

export default BankAccountToolTip;
